<template>

  <div v-if="this.category === true">
    <button type="button"
      class="border border-black p-s3 m_1000:p-0 m_1000:border-none m_1000:text-gold m_1000:hover:text-black m_1000:transition-colors m_1000:duration-200"
      @click="addToWishlist()">
      <span class="sr-only">Lista želja</span>
      <heart-icon svgClassName="size-s20 m_426:size-s25"></heart-icon>
    </button>
  </div>

  <div v-else>
    <button class="text-black flex gap-s10 items-center mt-s10 group w-fit mx-auto m_1000:mx-0 js_product_wishlist"
      @click="addToWishlist()">
      <div class="text-gold size-s25 m_1200:size-s28">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256" class="w-full">
          <path
            d="M221.6,58.38a56.06,56.06,0,0,0-79.12-.08L128,71.78,113.52,58.3a56,56,0,0,0-79.15,79.25l89.36,90.66a6,6,0,0,0,8.54,0l89.33-90.62a56,56,0,0,0,0-79.21Zm-8.52,70.75L128,215.45,42.89,129.1a44,44,0,0,1,62.22-62.23,1.07,1.07,0,0,0,.16.14l18.64,17.36a6,6,0,0,0,8.18,0L150.73,67a1.07,1.07,0,0,0,.16-.14,44,44,0,1,1,62.19,62.26Z">
          </path>
        </svg>
      </div>

      <p class="text-t14 m_1000:group-hover:text-gold m_1000:transition-colors m_1000:duration-200 m_1200:text-t16">
        Dodaj u listu želja</p>
    </button>
  </div>

</template>

<script>
export default {
  name: "AddToWishlist",

  props: [
    'productId',
    'category',
    'product'
  ],

  methods: {

    addToWishlist() {

	    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_wishlist",
        ecommerce: {
          currency: "RSD",
          value: this.product.final_price,
          items: [
            {
              item_id: this.product.movem_id,
              item_name: this.product.title,
              discount: this.product.discount,
              index: 0,
              item_brand: this.product.brend.title,
              item_category: this.getCategoriesForFeed(),
              price: this.product.final_price,
              quantity: 1
            }
          ]
        }
      });

      axios.post('/dodaj-u-listu-zelja', {id: this.productId})
          .then(response => {

	          // Preview message
            this.$toasted.global.toastSuccess({ message: response.data.message });

	          // Update vuex store, wishlist count
            this.$store.dispatch('Cart/changeWishlistItemCount', response.data.wishlistItemsCount);
          })
          .catch(error => {

            window.location.href = 'https://movem.rs/login';
	          //window.location.href = 'http://localhost/login';
            //this.$toasted.global.toastError({ message: 'Morate biti ulogovani.' });
          })

    },
    getCategoriesForFeed() {
      if (this.product.categories_for_feed) {
        this.product.categories_for_feed.forEach(function (value, i) {
          'item_category' + (i + 1) + ':' + value;
        })
      }
    }
  }

}
</script>
